/* Algolia click + conversion tracking — direct REST calls to the Insights API, no external
   library (consistent with this theme's no-bundler convention). Confirmed missing entirely
   before this: Algolia's own Analytics API returned trackedSearchCount:0 / clickCount:0
   despite ~1,200+ tracked searches/week, and no aa()/Insights code existed anywhere in the
   theme. This is the prerequisite for Algolia's Personalization, Dynamic Re-Ranking, and any
   meaningful A/B test — all of them learn from click/conversion signal that didn't exist yet.

   Two responsibilities:
   1. window.cdwAlgoliaInsights.recordClick(...) — called by the search results page
      (cpap-search-page.js) when a shopper clicks a result.
   2. A one-time fetch() wrap that catches every /cart/add(.js) call site-wide (quick-add,
      Buy Now, sticky bar — all of them, regardless of which PDP template made the call) and
      fires a conversion event if the variant added was recently clicked from a search result.
      localStorage (not sessionStorage) so a conversion still counts if the shopper closes the
      tab and comes back later — Algolia's own guidance treats same-session-only as too narrow. */
(function () {
  'use strict';

  // Same public, search-only key already embedded directly in cpap-search-page.liquid's
  // rendered HTML (data-algolia-key) — duplicating it here adds no new exposure.
  var ALGOLIA_APP_ID = 'MTW285YVQT';
  var ALGOLIA_SEARCH_KEY = '5a599fa6459d57fc3e6f0097cc283565';
  var ALGOLIA_INDEX = 'shopify_products';

  var STORAGE_KEY = 'cdw_algolia_click_history';
  var TOKEN_KEY = 'cdw_algolia_user_token';
  var MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; // 14 days — generous but bounded
  var MAX_ENTRIES = 50;

  // Algolia's Insights API requires a userToken on every event (confirmed live: omitting it
  // returns a 422 "The userToken field is required") — a persistent anonymous per-visitor id,
  // not tied to a real customer identity. Generated once, reused for the life of the browser.
  function getUserToken() {
    try {
      var existing = localStorage.getItem(TOKEN_KEY);
      if (existing) return existing;
      var token = 'anon-' + (window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + Math.random().toString(36).slice(2));
      localStorage.setItem(TOKEN_KEY, token);
      return token;
    } catch (e) {
      return 'anon-' + Date.now().toString(36);
    }
  }

  function loadHistory() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      var cutoff = Date.now() - MAX_AGE_MS;
      return arr.filter(function (e) { return e && e.ts > cutoff; });
    } catch (e) {
      return [];
    }
  }

  function saveHistory(arr) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(-MAX_ENTRIES)));
    } catch (e) {
      /* storage unavailable (private mode, quota) — tracking is best-effort, never block the page */
    }
  }

  function sendInsightsEvent(payload) {
    payload.userToken = getUserToken();
    fetch('https://insights.algolia.io/1/events', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Algolia-Application-Id': ALGOLIA_APP_ID,
        'X-Algolia-API-Key': ALGOLIA_SEARCH_KEY
      },
      body: JSON.stringify({ events: [payload] }),
      keepalive: true
    }).catch(function () {});
  }

  window.cdwAlgoliaInsights = window.cdwAlgoliaInsights || {};

  window.cdwAlgoliaInsights.recordClick = function (queryID, objectID, position) {
    if (!queryID || !objectID) return;
    sendInsightsEvent({
      eventType: 'click',
      eventName: 'Product Clicked',
      index: ALGOLIA_INDEX,
      queryID: queryID,
      objectIDs: [String(objectID)],
      positions: [position || 1]
    });
    var history = loadHistory();
    history.push({ queryID: queryID, objectID: String(objectID), ts: Date.now() });
    saveHistory(history);
  };

  // Site-wide conversion capture — wraps fetch exactly once, on script load.
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.indexOf('/cart/add') === -1) return origFetch.apply(this, arguments);

    return origFetch.apply(this, arguments).then(function (response) {
      if (response.ok) {
        try {
          var body = init && init.body ? JSON.parse(init.body) : null;
          var items = (body && body.items) || (body && body.id ? [{ id: body.id }] : []);
          var variantIds = items.map(function (it) { return String(it.id); });
          var history = loadHistory();
          var firedKeys = {};
          history.forEach(function (entry) {
            if (variantIds.indexOf(entry.objectID) === -1) return;
            var k = entry.queryID + ':' + entry.objectID;
            if (firedKeys[k]) return;
            firedKeys[k] = true;
            sendInsightsEvent({
              eventType: 'conversion',
              eventName: 'Product Added To Cart',
              index: ALGOLIA_INDEX,
              queryID: entry.queryID,
              objectIDs: [entry.objectID]
            });
          });
          // Clicks stay in history after converting — a repeat purchase of the same
          // variant is a real second conversion, not a duplicate to suppress.
        } catch (e) {
          /* malformed body or storage issue — never let tracking break a real add-to-cart */
        }
      }
      return response;
    });
  };
})();
